export function mask(input, maskPattern) {
    var d = { 9: '[0-9]', a: '[a-z]' };
    var mask = maskPattern.split('');
    var keyDownHandler = function (e) {
        // backspace key or delete key
        if (e.keyCode === 8 || e.keyCode === 46) {
            e.preventDefault();
            var mskd = [];
            var startSelection = input.selectionStart;
            if (startSelection == 0)
                return;
            var selection = startSelection;
            var onlyLodash = true;
            for (var index = mask.length - 1; index >= 0; index--) {
                var el = mask[index];
                if (d[el]) {
                    var t = new RegExp(d[el], 'i').test(input.value.charAt(index));
                    if (t && index != startSelection - 1) {
                        onlyLodash = false;
                    }
                    if (index === startSelection - 1)
                        selection--;
                    mskd.push(t && index != startSelection - 1
                        ? input.value.charAt(index)
                        : '_');
                }
                else {
                    if (index === selection - 1)
                        selection--;
                    if (startSelection - 1 === index)
                        startSelection--;
                    mskd.push(el);
                }
            }
            input.value = !onlyLodash ? mskd.reverse().join('') : '';
            input.selectionStart = input.selectionEnd = selection < 0 ? 0 : selection;
            var event_1 = document.createEvent('Event');
            event_1.initEvent('input', true, true);
            input.dispatchEvent(event_1);
        }
    };
    var keyPressHandler = function (e) {
        var char = String.fromCharCode(e.charCode);
        if (char) {
            e.preventDefault();
            var mskd_1 = [];
            var selectionStart_1 = input.selectionStart;
            var selection_1 = selectionStart_1;
            mask.forEach(function (el, index) {
                if (d[el]) {
                    var ch = (index != selectionStart_1)
                        ? input.value.charAt(index)
                        : char;
                    var t = new RegExp(d[el], 'i').test(ch);
                    mskd_1.push(t ? ch : '_');
                    if (t && selectionStart_1 === index)
                        selection_1++;
                }
                else {
                    mskd_1.push(el);
                    if (selection_1 === index)
                        selection_1++;
                    if (selectionStart_1 === index)
                        selectionStart_1++;
                }
            });
            input.value = mskd_1.join('');
            input.selectionStart = input.selectionEnd = selection_1;
            var event_2 = document.createEvent('Event');
            event_2.initEvent('input', true, true);
            input.dispatchEvent(event_2);
        }
    };
    var inputHandler = function (e) {
        if (e.type === 'focus' && input.value !== '')
            return;
        var mskd = [];
        var startSelection = input.selectionStart;
        mask.forEach(function (el, index) {
            if (d[el]) {
                var t = new RegExp(d[el], 'i').test(input.value.charAt(index));
                mskd.push(t ? input.value.charAt(index) : '_');
            }
            else {
                mskd.push(el);
            }
        });
        input.value = mskd.join('');
        input.selectionStart = input.selectionEnd = startSelection;
    };
    input.addEventListener('keydown', keyDownHandler);
    input.addEventListener('keypress', keyPressHandler);
    input.addEventListener('input', inputHandler);
    input.addEventListener('focus', inputHandler);
}
//# sourceMappingURL=mask.js.map